import { api } from "@/api/client";
import type { PaginatedResponse, SearchResult } from "@/api/types";

export const searchFiles = (query: string, limit = 50, offset = 0) =>
  api.get<PaginatedResponse<SearchResult>>("/v1/search", { q: query, limit, offset });
